import {
  NgFor,
  NgIf,
} from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';

import { Item } from '../../../../../../../../app/core/shared/item.model';
import { MetadataValue } from '../../../../../../../../app/core/shared/metadata.models';
import { MetadataFieldWrapperComponent } from '../../../../../../../../app/shared/metadata-field-wrapper/metadata-field-wrapper.component';

@Component({
  selector: 'ds-language-item-page-field',
  templateUrl: './language-item-page-field.component.html',
  standalone: true,
  imports: [MetadataFieldWrapperComponent, NgFor, NgIf, TranslateModule],
})
/**
 * Renders language code metadata values.
 */
export class LanguageItemPageFieldComponent {

  @Input() item: Item;
  @Input() fields: string[] = ['dc.language.iso'];
  @Input() label = 'item.page.language';
  @Input() separator = '<br/>';

  constructor(
    protected translateService: TranslateService,
  ) {
  }

  get values(): MetadataValue[] {
    return this.item?.allMetadata(this.fields) ?? [];
  }

  /**
   * Returns the name of the given language.
   */
  getLanguageName(code: string): string {
    if (!code) {
      return code;
    }
    try {
      const displayNames = new Intl.DisplayNames([this.translateService.currentLang ?? 'de'], { type: 'language', fallback: 'none' });
      return displayNames.of(code.trim().split(/[_-]/)[0]) ?? code;
    } catch (e) {
      return code;
    }
  }

}
